import { StoreItemCategory, StorePresalePackType } from '../../entity_datas/StoreEnums.ts';
import { BaseStoreItem } from '../BaseStoreItem.ts';
import { LobbyImage } from '@colonist/types';
export class SISettlerPack extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.PresalePack, this.type = StorePresalePackType.SettlerPack, this.name = {
            key: 'strings:storePage.packs.settler.title'
        }, this.description = 'strings:storePage.packs.settler.description', this.price = 999999999, this.image = LobbyImage.SettlerPack;
    }
}
export class SIColonistPack extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.PresalePack, this.type = StorePresalePackType.ColonistPack, this.name = {
            key: 'strings:storePage.packs.colonist.title'
        }, this.description = 'strings:storePage.packs.colonist.description', this.price = 999999999, this.image = LobbyImage.ColonistPack;
    }
}
export class SIFounderPack extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.PresalePack, this.type = StorePresalePackType.FounderPack, this.name = {
            key: 'strings:storePage.packs.founder.title'
        }, this.description = 'strings:storePage.packs.founder.description', this.price = 999999999, this.image = LobbyImage.FounderPack;
    }
}
